import {Component, OnInit} from '@angular/core';
import {HouseFundBonusService} from '../../../shared/services/house-fund-bonus.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-house-fund-bonus',
  templateUrl: './house-fund-bonus.component.html',
  styleUrls: ['./house-fund-bonus.component.scss']
})
export class HouseFundBonusComponent implements OnInit {
  submitting = false;
  houseFundBonus = [];
  total: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public houseFundBonusService: HouseFundBonusService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'transaction_no': [''],
      'sender_id': [''],
      'commission': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.houseFundBonus = [];
    this.houseFundBonusService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.houseFundBonus = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.total = data.total_commission;
        this.triggerScroll();
      } else {
        this.houseFundBonus = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'transaction_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.transaction_no : '',
      'sender_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.sender_id : '',
      'commission': (this.searchForm && this.searchForm.value) ? this.searchForm.value.commission : '',
    };
    this.get(params);
  }
}
